import plutioProvider from "../../providers/prod/plutio";
import {
	Asset,
	Resource,
	ResourceStatus,
	ResourceType,
} from "../../../../index";

const r001Resource = new Resource({
	internalId: "r001",
	externalId: "string",
	name: "Plutio Themes",
	shortDescription: "Plutio Themes is a collection of themes for Plutio.",
	longDescription: "Plutio Themes is a collection of themes for Plutio.",
	type: ResourceType.SETTINGS,
	coverAsset: Asset.image(
		"https://storage.googleapis.com/cdn.version2.io/add-ons/a001/icons/a001_icon_rounded.png"
	),
	previewAssets: [],
	docsUrl: "https://docs.version2.io/2yBk3DCZZawB6CXhr",
	providersIds: [plutioProvider._.id],
	status: ResourceStatus.ACTIVE,
	links: [],
});
 
export default r001Resource;
